import { IconButton, Icon, Icons } from '@silverfort/sf-components';
export const StatusBadgeVariants = {
    Danger: 'danger'
};

const variantClassMapper = {
    [StatusBadgeVariants.Danger]: {
        general: 'bg-sf-negative-100 border border-sf-negative-500 text-sf-sf-gray-800',
        icon: 'text-sf-negative-500'
    }
};

const TopBanner = ({ icon, title = '', variant = StatusBadgeVariants.Danger, show, onClose, className }) => {
    return (
        <div
            className={`absolute z-[9500] top-0 pl-16 w-full flex items-center duration-500 h-16 font-sf ${
                show ? 'block' : 'hidden'
            } ${variantClassMapper[variant].general} ${className}`}>
            <div className={`w-full flex items-center ${show ? 'opacity-100' : 'opacity-0'} duration-500`}>
                {icon && <Icon icon={icon} className={`${variantClassMapper[variant].icon} pl-4 h-4 w-4`} />}
                <div className="text-12 pl-1 font-medium">{title}</div>
            </div>
            <IconButton onClick={onClose} icon={Icons.Cancel} className="float-end pr-4"></IconButton>
        </div>
    );
};

export default TopBanner;
